export { default } from './TableFooter';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/TableFooter/index.js
// module id = 362
// module chunks = 0